exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".code-snippet {\n  position: relative;\n  z-index: 1;\n}\n.code-snippet .button {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n}\n.code-snippet-no-copy .CodeMirror {\n  padding: 20px 0;\n}\n", ""]);

